import { extendFormControlExistingRule } from '../../hoc/form/Rules';
import { FORM_CONTROL_VALIDATE_TYPES } from '../../hoc/form/Types';

export const config = {
  filterName: {
    required: true,
    valid: true,
    value: '',
    rules: [(value: string) => ({
      'data-error': 'requiredField',
      valid: !/^\s*$/.test(value)
    }), extendFormControlExistingRule(FORM_CONTROL_VALIDATE_TYPES.maxTextLength, {})
    ]
  },
  filterColor: {
    valid: true,
    value: 'no_color'
  }
};
